{
  "nav": {
    "label": "Sezioni di DEC Capital",
    "home": "Torna a DEC Energy",
    "top": "DEC Capital, torna all'inizio",
    "now": "Perché ora",
    "about": "Cosa facciamo",
    "why": "La nostra storia",
    "strategy": "Strategia",
    "people": "Comitato",
    "contact": "Contatti",
    "cta": "Richiedi informazioni"
  },
  "hero": {
    "eyebrow": "Per investitori professionali e qualificati",
    "title": "Acquista quote di ricavi da impianti rinnovabili.",
    "subtitle": "Partecipa alla <strong>redditività generata da impianti rinnovabili</strong> già in esercizio con un modello che garantisce massima diversificazione e protezione contrattuale, <strong>senza acquistare gli asset</strong>."
  },
  "thesis": {
    "heading": "La finanza a sostegno dell'energia rinnovabile",
    "actor": {
      "investor": "Investitori",
      "producer": "Produttori"
    },
    "benefit": {
      "investor": "<strong>Esposizione al rendimento</strong> prodotto da asset rinnovabili operativi massimizzando la velocità di deployment e riducendo i rischi.",
      "producer": "<strong>Capitale immediato</strong> sotto forma di semi-equity senza vendere i propri impianti né aumentare l'indebitamento."
    },
    "model": {
      "title": "Il modello",
      "text": "Una struttura contrattuale con cui si acquistano <strong>ricavi ricorrenti</strong>\nda impianti rinnovabili operativi."
    }
  },
  "investment": {
    "eyebrow": "I vantaggi",
    "heading": "Investire in rinnovabili con DEC Capital è:",
    "immediate": {
      "title": "Immediato",
      "text": "<strong>Impianti già in produzione</strong>, senza attese di cantiere o autorizzazioni."
    },
    "diversified": {
      "title": "Diversificato",
      "text": "Ricavi da un <strong>portafoglio diversificato</strong> di impianti, produttori e modalità di vendita di energia."
    },
    "lowerRisk": {
      "title": "A rischio contenuto",
      "text": "<strong>CAPEX ridotto</strong> rispetto all'acquisto di impianti. Floor di produzione e garanzie di pagamento."
    },
    "noOwnership": {
      "title": "Senza proprietà",
      "text": "<strong>Posizione creditizia prioritaria</strong> rispetto all'equity, subordinata solo al finanziatore senior."
    }
  },
  "whyDec": {
    "heading": "Il legame con DEC Energy",
    "lede": "La rete, il modello e l'esperienza accumulati da DEC Energy nel mondo industriale, valorizzati e messi a disposizione degli investitori.",
    "network": {
      "title": "La rete",
      "text": "Attraverso la <strong>nostra rete di produttori</strong>, selezioniamo gli impianti che soddisfano i requisiti della strategia di investimento."
    },
    "model": {
      "title": "Il modello",
      "text": "DEC Energy è <strong>l'inventore di questo modello</strong>, già validato in ambito industriale siglando accordi con produttori e consumatori italiani e svizzeri."
    },
    "experience": {
      "title": "L'esperienza",
      "text": "Le persone che guidano DEC Capital mettono a disposizione un'<strong>esperienza cumulata di 100 anni</strong> nelle energie rinnovabili."
    }
  },
  "whyNow": {
    "eyebrow": "Una finestra di mercato, una grande opportunità",
    "title": "Una finestra di mercato,",
    "turn": "una grande opportunità.",
    "incentives": "I produttori di energia vogliono realizzare più impianti per beneficiare a pieno degli <strong>incentivi disponibili</strong> (FER X, Energy Release 2.0, …).",
    "debt": "Ma le <strong>soluzioni finanziarie a disposizione sono limitate</strong> e vendere i propri impianti non è una possibilità.",
    "gap": "Manca un modello che fornisca <strong>liquidità immediata</strong> senza aumentare l'indebitamento o vendere impianti."
  },
  "interlude": {
    "eyebrow": "Panoramica delle opportunità",
    "heading": "Alcuni degli impianti contrattualizzati o in negoziazione",
    "prev": "Impianti precedenti",
    "next": "Impianti successivi",
    "plants": {
      "solar": "Fotovoltaico",
      "wind": "Eolico"
    },
    "power": "{{mw}} MWp"
  },
  "trackRecord": {
    "eyebrow": "Track record",
    "heading": "Già operativo, non sulla carta.",
    "proof": "Il modello è <strong>consolidato da decenni</strong> nei settori dell'oil & gas, del minerario e delle rinnovabili all'estero. DEC Energy lo ha portato sulle rinnovabili europee, insieme ad aziende leader nel settore dell'energia e oltre.",
    "producers": {
      "value": "{{n}}+",
      "label": "Produttori con impianti in Italia"
    },
    "volume": {
      "value": "{{n}} GWh",
      "label": "Conclusi o in negoziazione avanzata sul modello DEC Energy"
    },
    "fintech": {
      "value": "3ª",
      "label": "Startup fintech in Svizzera"
    },
    "energyFintech": {
      "value": "1ª",
      "label": "Startup energy-fintech in Italia"
    }
  },
  "strategy": {
    "heading": "Partecipare alle rinnovabili riducendone i rischi",
    "portfolio": {
      "title": "Strategia di portafoglio",
      "route": "Prevalenza di modalità di vendita dell'energia <strong>a tariffa fissa</strong> (FER 1, FER X, …)",
      "producers": "Prevalenza di <strong>produttori di grandi dimensioni</strong> (utility e IPP)",
      "technology": "Prevalenza di <strong>impianti fotovoltaici</strong>, con una quota di eolico"
    },
    "risk": {
      "title": "Profilo di rischio",
      "operating": "<strong>Solo impianti</strong> già allacciati e in produzione",
      "floor": "<strong>Floor di produzione</strong> garantito dal proprietario",
      "seniority": "<strong>Posizione senior</strong> rispetto all'equity",
      "payments": "<strong>Garanzie di pagamento</strong> sugli importi dovuti"
    }
  },
  "people": {
    "eyebrow": "Comitato di investimento",
    "heading": "Oltre 100 anni di esperienza nelle energie rinnovabili",
    "roles": {
      "scarinzi": "Co-founder e CEO @DEC Energy",
      "bonu": "Co-founder e COO @DEC Energy",
      "rossi": "Ex-CEO AET e AEM",
      "truglio": "Country manager Italy RP Global",
      "piccioliFaccoli": "CIO Nvalue"
    },
    "linkedin": "Profilo LinkedIn di {{name}}"
  },
  "contact": {
    "heading": "Il prossimo passo",
    "body": "Un incontro con il management per illustrare pipeline, contratti e approfondire le modalità di collaborazione.",
    "sentTitle": "Richiesta inviata",
    "sent": "Grazie, abbiamo ricevuto la tua richiesta. Ti ricontatteremo a breve."
  },
  "form": {
    "fields": {
      "name": {
        "label": "Nome e cognome",
        "error": "Inserisci nome e cognome"
      },
      "company_name": {
        "label": "Società",
        "error": "Inserisci la società"
      },
      "email": {
        "label": "Email",
        "error": "Inserisci un indirizzo email valido"
      },
      "number": {
        "label": "Telefono",
        "required": "Inserisci il numero di telefono",
        "invalid": "Inserisci un numero di telefono valido"
      },
      "user_type": {
        "label": "Profilo",
        "error": "Seleziona un profilo"
      },
      "additional_info": {
        "label": "Messaggio (facoltativo)"
      }
    },
    "submit": "Invia richiesta",
    "select": "Seleziona"
  },
  "investorTypes": {
    "familyOffice": "Family office",
    "privateBank": "Private bank",
    "privateInvestor": "Investitore privato",
    "institutional": "Investitore istituzionale",
    "producer": "Produttore di energia",
    "industrial": "Investitore industriale",
    "other": "Altro"
  },
  "footer": {
    "tagline": "Acquista quote di ricavi da impianti rinnovabili"
  }
}
